import React, { useState, useEffect } from 'react';
import { wsGetAll } from 'services/WService';

import TextField from '@material-ui/core/TextField';
import Autocomplete from '@material-ui/lab/Autocomplete';
import Modal from 'components/Tvendo/Common/ModalBase';

export default function ModalProviderGroup(props) {
  const providerGroup = props.model;

  const [dataChanging, setDataChanging] = useState(providerGroup);
  const [businessPartners, setBusinessPartners] = useState([]);

  async function listBusinessPartners() {
    let response = await wsGetAll('base/business-partner?CardType=S&QryGroup1=Y');
    if (response.success) setBusinessPartners(response.data);
  }

  function handleChange(field, value) {
    setDataChanging({ ...dataChanging, [field]: value });
  }

  useEffect(() => {
    if (providerGroup.open) {
      listBusinessPartners();
    }
  }, [providerGroup.open]);

  return (
    <Modal
      title="Grupo proveedor"
      model={providerGroup}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      dataChanging={dataChanging}
      setDataChanging={setDataChanging}
      entity="com/provider-group"
    >
      <TextField
        label="Descripción"
        fullWidth
        type="text"
        name="description"
        margin="normal"
        defaultValue={providerGroup.description || ''}
        required
      />
      {businessPartners.length > 0 ? (
        <Autocomplete
          disableClearable
          options={businessPartners}
          getOptionLabel={(option) => option.CardName}
          defaultValue={
            !!providerGroup
              ? businessPartners.find(
                  (businessP) => businessP.id == providerGroup.base_business_partner_id
                )
              : undefined
          }
          renderInput={(params) => (
            <TextField {...params} label="Socio de Negocio" margin="normal" required />
          )}
          onChange={(e, item) => {
            if (!!item) {
              return handleChange('base_business_partner_id', item.id);
            }
            handleChange('base_business_partner_id', null);
          }}
        />
      ) : undefined}
    </Modal>
  );
}
